import { createSlice } from "@reduxjs/toolkit";
import { getEventsTable } from "../../actions/events/getEventsTable";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getEventsTableReducer = createSlice({
  name: "getEventsTableReducer",
  initialState,
  reducers: {
    cleargetEventsTableReducer: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEventsTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEventsTable.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEventsTable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { cleargetEventsTableReducer } = getEventsTableReducer.actions;
export default getEventsTableReducer.reducer;
